import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import $ from "jquery";
import "../css/simple-line-icons.css";
import Banner from "./banner";
import Welcome from "./welcome";
import BannerBottom from "./bannerBottom";
import Testimonial from "./testimonial";
import Gallery from "./gallery";
import { apiCalling } from "../apiService";
import { Helmet } from "react-helmet";
import Calender from "../healthTrackerCalender/health-trackers";
// import AdSense from "react-adsense";

export default class home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bannerData: [],
      missionData: [],
      bouquetData: [],
      centreData: [],
      aboutData: [],
    };
  }

  componentDidMount() {
    const bannerData = JSON.parse(window.sessionStorage.getItem("Banner"));
    const missionData = JSON.parse(window.sessionStorage.getItem("Mission"));
    const Bouquet = JSON.parse(window.sessionStorage.getItem("Bouquet"));
    const Centre = JSON.parse(window.sessionStorage.getItem("Centre"));
    const About = JSON.parse(window.sessionStorage.getItem("About"));

    if (bannerData) {
      this.setState({ bannerData: bannerData[0].sectionList });
    }
    if (missionData) {
      this.setState({ missionData: missionData[0].sectionList });
    }
    if (Bouquet) {
      this.setState({ bouquetData: Bouquet[0].sectionList });
    }
    if (Centre) {
      this.setState({ centreData: Centre[0].sectionList });
    }
    if (About) {
      this.setState({ aboutData: About[0].sectionList });
    }

    $(".booknow").hide();
    //window.sessionStorage.setItem("siteId", this.state.siteId);
    $(".layoutPatientMenuTop").hide();
    $(".layoutDoctorMenuTop").hide();
  }
  render() {
    window.onscroll = function () {
      myFunction();
    };
    function myFunction() {
      // var ff = $(".welcomeMain").position();
      // if (
      //document.body.scrollTop > ff.top ||
      // document.documentElement.scrollTop > ff.top
      // ) {
      //$(".booknow").show();
      // } else {
      //  $(".booknow").hide();
      // }
    }
    return (
      <div class="mentalHealthWrap">
        <Helmet>
          <title>{window.sessionStorage.getItem("seo_title")}</title>
          <meta
            name="description"
            content={window.sessionStorage.getItem("seo_description")}
          />
          <meta
            name="keywords"
            content={window.sessionStorage.getItem("seo_keywords")}
          ></meta>
          <meta
            name="twitter:title"
            content={window.sessionStorage.getItem("seo_title")}
          ></meta>
          <meta
            name="twitter:description"
            content={window.sessionStorage.getItem("seo_description")}
          ></meta>
          <meta
            name="twitter:image:src"
            content={window.sessionStorage.getItem("siteLogo")}
          ></meta>
          <meta
            name="facebook:title"
            content={window.sessionStorage.getItem("seo_title")}
          ></meta>
          <meta
            name="facebook:description"
            content={window.sessionStorage.getItem("seo_description")}
          ></meta>
          <meta
            name="facebook:image:src"
            content={window.sessionStorage.getItem("siteLogo")}
          ></meta>
          <meta
            property="og:title"
            content={window.sessionStorage.getItem("seo_title")}
          ></meta>
          <meta
            property="og:image"
            content={window.sessionStorage.getItem("siteLogo")}
          ></meta>
          <meta
            property="og:description"
            content={window.sessionStorage.getItem("seo_description")}
          ></meta>
          <meta
            property="og:url"
            content={window.sessionStorage.getItem("slug")}
          ></meta>
        </Helmet>
        <div class="metalContent">
          {this.state.bannerData.length > 0 ? <Banner></Banner> : ""}
          {this.state.missionData.length > 0 ? (
            <BannerBottom></BannerBottom>
          ) : (
            ""
          )}
          {this.state.aboutData.length > 0 ? (
            <div class="container">
              <Welcome></Welcome>
            </div>
          ) : (
            ""
          )}
          {/* <MiddleBanner></MiddleBanner> */}
          {/* <div class="container">
            <Specialist></Specialist>
          </div> */}
          {/* <Booknow></Booknow> */}
          {this.state.centreData.length > 0 ? <Testimonial></Testimonial> : ""}
          {this.state.bouquetData.length > 0 ? <Gallery /> : ""}

          {window.sessionStorage.getItem("hasHealthTracker") === "true" && (
            <Calender />
          )}
        </div>
        <div className="google-ads-div">
          {/* <AdSense.Google
            client="ca-pub-8245098054086430"
            slot="8560747531"
            style={{ display: "block",width: 500, height: 300 }}
            layout="in-article"
            format="fluid"
          /> */}
        </div>
      </div>
    );
  }
}
